// extracted by mini-css-extract-plugin
export default {"container":"zVDOlIZ9uhQ92HpefbH7","title":"uB7JKrs1FwWXyedeVb7A","subtitle":"psOFlIXf5Wk9a8O2I93I"};